import { AutomaticLayout } from "./implementations/automatic-layout.js";
import { RandomLayout } from "./implementations/basic-layout.js";
import { ElkLayout } from "./implementations/elk-layout.js";
import { ElkProfileLayout } from "./implementations/elk-profile-specific-layout.js";
import { NoActionLayout } from "./implementations/no-action-layouts.js";
export const ALGORITHM_NAME_TO_LAYOUT_MAPPING = {
    "elk_stress": new ElkLayout(),
    "elk_layered": new ElkLayout(),
    "elk_force": new ElkLayout(),
    "random": new RandomLayout(),
    "elk_radial": new ElkLayout(),
    "elk_overlapRemoval": new ElkLayout(),
    "elk_stress_advanced_using_clusters": new ElkLayout(),
    "elk_stress_profile": new ElkProfileLayout(),
    "none": new NoActionLayout(),
    "automatic": new AutomaticLayout(),
};
//# sourceMappingURL=list-of-layout-algorithms.js.map